import { render, staticRenderFns } from "./CourseTypeField.vue?vue&type=template&id=84e31238"
import script from "./CourseTypeField.vue?vue&type=script&lang=js"
export * from "./CourseTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports